/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import './scss/styles.scss';
import './util/polyfills';

import ReactDOM from 'react-dom';

import { apiSetup } from '@ibm-watson/shared/modules/ia/api';
import { AppShell } from './AppShell';
import { getStore } from './store';

/**
 * This module is the main entrypoint into the Tooling application
 * when it is loaded as a stand-alone application, in other words, NOT
 * as a part of watsonx Orchestrate (WXO).
 *
 * Aside from mounting the top-level React component for the entire
 * application on a well-known DOM node, it also loads the CSS classes
 * needed to style the application and loads whatever polyfills are needed
 * to provide a consistent experience across all supported browsers.
 */

// Configure the Axios instance with the appropriate interceptors for
// handling API requests and responses.
apiSetup(getStore);

// Load the top-level React component into the DOM mode with the well-known
// ID "app" (which is provided by the "index.html" that was used to load
// the page).
ReactDOM.render(<AppShell />, document.getElementById('app'));
